@if (participant) {
  <div class="pdd-backdrop" [class.is-open]="isOpen" (click)="onClose()"></div>

  <aside class="pdd-drawer" [class.is-open]="isOpen">
    <div class="dw-head">
      <div class="dw-head__top">
        <div class="dw-avatar"><i class="fa-solid fa-user"></i></div>
        <div class="dw-head-main">
          <h3 class="dw-title">Détails participant</h3>
        </div>
        <button type="button" class="dw-close" (click)="onClose()" title="Fermer" aria-label="Fermer">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      @if (isDirty) {
        <button type="button" class="ui-btn ui-btn--primary ui-btn--sm dw-save" (click)="onSave()">
          <i class="fa-solid fa-floppy-disk"></i> Enregistrer
        </button>
      }
    </div>

    @if (isBlocked) {
      <div class="block-banner">
        <i class="fa-solid fa-ban"></i>
        <span>Ce billet a été <strong>bloqué</strong>. Les contrôles sont désactivés.</span>
      </div>
    }

    <div class="dw-body">
      <section class="sec">
        <header class="sec__head">
          <span class="sec__icon"><i class="fa-solid fa-ticket"></i></span>
          <h4 class="sec__title">Informations billet</h4>
        </header>
        <div class="sec__body">
          <dl class="kv">
            <dt>Nom :</dt>
            <dd>
              <input type="text" class="boc-input boc-input--sm"
                     [(ngModel)]="lastNameDraft"
                     [disabled]="isBlocked"
                     aria-label="Nom"/>
            </dd>

            <dt>Prénom :</dt>
            <dd>
              <input type="text" class="boc-input boc-input--sm"
                     [(ngModel)]="firstNameDraft"
                     [disabled]="isBlocked"
                     aria-label="Prénom"/>
            </dd>

            <dt>Type du tarif :</dt>
            <dd>
              <div class="tpl-row">
                <input
                  class="boc-input boc-input--sm tpl-current-input"
                  [class.tpl-current-input--clickable]="canChangeTpl"
                  [value]="participant.tplName"
                  readonly
                  (click)="onToggleTplDropdown()"/>
                @if (canChangeTpl) {
                  <i class="fa-solid tpl-chevron"
                     [class.fa-chevron-down]="!tplDropdownOpen"
                     [class.fa-chevron-up]="tplDropdownOpen"></i>
                } @else if (isLoadingTpls) {
                  <i class="fa-solid fa-spinner fa-spin tpl-chevron"></i>
                }
                @if (tplDropdownOpen && canChangeTpl) {
                  <div class="tpl-dropdown">
                    <input type="text" class="boc-input boc-input--sm tpl-search" placeholder="Rechercher un tarif..." [(ngModel)]="tplFilter"/>
                    <div class="tpl-list">
                      @for (tpl of filteredTpls; track trackById($index, tpl)) {
                        <div class="tpl-item" (click)="onSelectTpl(tpl)">{{ tpl.name }}</div>
                      } @empty {
                        <div class="tpl-empty">Aucun tarif disponible</div>
                      }
                    </div>
                  </div>
                }
              </div>
              @if (!canChangeTpl) {
                <p class="tpl-hint muted">Uniquement les tarifs gratuits et importé peuvent être modifiés</p>
              }
            </dd>

            @if (participant.tplOriginalName) {
              <dt>Tarif d'origine :</dt>
              <dd class="muted">{{ participant.tplOriginalName }}</dd>
            }

            <dt>Réponses formulaire :</dt>
            <dd class="muted">{{ participant.formAnswers || 'Aucune donnée' }}</dd>

            <dt>Email participant :</dt>
            <dd><input class="boc-input boc-input--sm" [value]="participant.email" readonly/></dd>
          </dl>
        </div>
      </section>

      <section class="sec">
        <header class="sec__head">
          <span class="sec__icon"><i class="fa-solid fa-id-card"></i></span>
          <h4 class="sec__title">Billet & accès</h4>
        </header>
        <div class="sec__body">
          <dl class="kv">
            <dt>N° du code-barres :</dt>
            <dd><span class="mono">{{ participant.barcode }}</span></dd>

            <dt class="align-top">Code-barres :</dt>
            <dd class="stack"><svg #barcodeSvg class="barcode-svg"></svg></dd>

            <dt>Tag NFC :</dt>
            <dd>
              <div class="nfc-row">
                @if (isNfcLinked) {
                  <input class="nfc-input has-value"
                         [value]="participant.shortTag || participant.associatedNfc || ''"
                         disabled/>
                  <button type="button" class="nfc-btn nfc-btn--unlink"
                          [disabled]="isBlocked"
                          (click)="onDisassociateNfc()"
                          title="Déassocier le tag NFC"
                          aria-label="Déassocier le tag NFC">
                    <i class="fa-solid fa-link-slash"></i>
                  </button>
                } @else {
                  <input class="nfc-input"
                         [class.has-value]="!!nfcDraft"
                         placeholder="Saisir le tag NFC"
                         [(ngModel)]="nfcDraft"
                         [disabled]="isBlocked"/>
                  <button type="button" class="nfc-btn nfc-btn--link"
                          [disabled]="!nfcDraft || isBlocked"
                          (click)="onAssociateNfc()"
                          title="Associer le tag NFC"
                          aria-label="Associer le tag NFC">
                    <i class="fa-solid fa-link"></i>
                  </button>
                }
              </div>
            </dd>

            @if (isNfcLinked && participant.associatedNfc) {
              <dt>Id Tag cashless :</dt>
              <dd><input class="boc-input boc-input--sm mono" [value]="participant.associatedNfc" readonly/></dd>
            }

            @if (participant.pdfUrl) {
              <dt>Lien PDF :</dt>
              <dd>
                <a class="pdf-link" [href]="participant.pdfUrl" target="_blank" rel="noopener">
                  <i class="fa-solid fa-file-pdf"></i>
                  <span>Accéder au PDF</span>
                  <i class="fa-solid fa-arrow-up-right-from-square pdf-link__out"></i>
                </a>
              </dd>
            }
          </dl>
        </div>
      </section>

      <section class="sec">
        <header class="sec__head">
          <span class="sec__icon"><i class="fa-solid fa-clipboard-check"></i></span>
          <h4 class="sec__title">Contrôles</h4>
        </header>
        <div class="sec__body">
          <div class="counter">
            <div class="counter__stepper">
              <button type="button" class="counter__btn"
                      (click)="onDecrementScan()"
                      [disabled]="participant.totScan <= 0 || isBlocked">
                <i class="fa-solid fa-minus"></i>
              </button>
              <div class="counter__val">{{ participant.totScan }}<small> / {{ participant.maxScan }}</small></div>
              <button type="button" class="counter__btn"
                      (click)="onIncrementScan()"
                      [disabled]="participant.totScan >= participant.maxScan || isBlocked">
                <i class="fa-solid fa-plus"></i>
              </button>
            </div>
            <div class="counter__hint">
              Utilisez <strong>+</strong> ou <strong>−</strong> pour ajouter un contrôle d'entrée ou de sortie.
            </div>
          </div>
        </div>
      </section>

      <section class="sec">
        <header class="sec__head">
          <span class="sec__icon"><i class="fa-solid fa-clock-rotate-left"></i></span>
          <h4 class="sec__title">Historique</h4>
          <span class="sec__aside">Trié par date</span>
        </header>
        <div class="sec__body" [style.padding-top.px]="participant.history.length ? 4 : 14">
          @if (participant.history.length === 0) {
            <div class="hist-empty">Aucun contrôle n'a encore été effectué</div>
          } @else {
            <div class="hist">
              @for (entry of participant.history; track trackByIndex($index)) {
                <div class="hist__item">
                  <div class="hist__icon" [class]="historyIconClass(entry)">
                    <i class="fa-solid" [class]="historyIcon(entry)"></i>
                  </div>
                  <div class="hist__body">
                    <p class="hist__title">{{ entry.title }}</p>
                    <p class="hist__meta">
                      <i class="fa-regular fa-user"></i> {{ entry.who }}
                      <span class="dot">•</span>
                      <i class="fa-regular fa-clock"></i> {{ entry.when }}
                      <span class="dot">•</span>
                      <i class="fa-solid fa-mobile-screen"></i> {{ entry.device }}
                    </p>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </section>

      <div class="admin-id">
        <span class="admin-id__label">
          <i class="fa-solid fa-fingerprint"></i> Identifiant participant
        </span>
        <div class="admin-id__value">
          <code [title]="participant.id">{{ participant.id }}</code>
          <button type="button" class="admin-id__copy" title="Copier l'identifiant" (click)="copyId()">
            <i class="fa-regular fa-copy"></i>
          </button>
        </div>
      </div>
    </div>

    <footer class="dw-footer">
      <button type="button" class="ui-btn ui-btn--ghost ui-btn--sm dw-footer__btn" [class.is-active]="isMarked" (click)="onToggleFlag()">
        <i class="fa-solid fa-flag"></i> {{ isMarked ? 'Démarquer' : 'Marquer' }}
      </button>
      <button type="button" class="ui-btn ui-btn--ghost-danger ui-btn--sm dw-footer__btn" [class.is-active]="isBlocked" (click)="onToggleBan()">
        <i class="fa-solid" [class.fa-lock-open]="isBlocked" [class.fa-ban]="!isBlocked"></i>
        {{ isBlocked ? 'Débloquer' : 'Bloquer' }}
      </button>
    </footer>

    @if (toast) {
      <div class="pdd-toast show">
        <i class="fa-solid" [class]="toast.icon"></i> {{ toast.msg }}
      </div>
    }
  </aside>
}
